import { useCallback } from 'react';
import noop from 'lodash/noop';
import { Button } from '@cbhq/cds-web/buttons';
import { Icon } from '@cbhq/cds-web/icons';
import { Pictogram } from '@cbhq/cds-web/illustrations';
import { HStack, VStack } from '@cbhq/cds-web/layout';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '@cbhq/cds-web/overlays';
import { TextBody, TextTitle3 } from '@cbhq/cds-web/typography';

type CancelSubscriptionModalProps = {
  onRequestClose: (shouldClose?: boolean) => void;
};

function CancelSubscriptionModal({ onRequestClose }: CancelSubscriptionModalProps) {
  const handleClose = useCallback(
    ({ shouldCancel }) => {
      onRequestClose(shouldCancel);
    },
    [onRequestClose],
  );
  return (
    <Modal hideDividers onRequestClose={onRequestClose || noop} visible>
      <ModalHeader />
      <ModalBody>
        <VStack gap={4} spacing={4} justifyContent="center">
          <HStack justifyContent="center" spacingBottom={4}>
            <Pictogram name="walletAsServiceNavigation" dimension="48x48" />
          </HStack>
          <TextTitle3 as="p">If you cancel your subscription, you will lose access to:</TextTitle3>
          <HStack gap={3}>
            <Icon name="checkmark" size="m" />
            <TextBody as="p">Your API access keys</TextBody>
          </HStack>
          <HStack gap={3}>
            <Icon name="checkmark" size="m" />
            <TextBody as="p">Your wallets</TextBody>
          </HStack>
          <HStack gap={3}>
            <Icon name="checkmark" size="m" />
            <TextBody as="p">The ability to send requests</TextBody>
          </HStack>
          <HStack gap={3}>
            <Icon name="checkmark" size="m" />
            <TextBody as="p">24/7 priority support</TextBody>
          </HStack>
        </VStack>
      </ModalBody>
      <ModalFooter
        primaryAction={
          <Button
            type="submit"
            onPress={() => handleClose({ shouldCancel: false })}
            testID="stay-subscribed"
          >
            Stay subscribed
          </Button>
        }
        secondaryAction={
          <Button
            variant="secondary"
            onPress={() => handleClose({ shouldCancel: true })}
            testID="cancel"
          >
            Continue cancelling
          </Button>
        }
      />
    </Modal>
  );
}

export default CancelSubscriptionModal;
